import React, { useContext } from 'react';

import Deal from './Deal';
import { useIsLarge } from '../../../../Components/Context/Hooks/mediaQueries';
import { BoxProps } from '../../../../Components/UI/Box';
import { canOpenNavigationForDeal } from '../../../../Utils/canOpenNavigation';
import useGlobalContext, { DealContext } from '../../Context';
import Navigation from '../Navigation';

const DealsNavigation: React.FC<BoxProps> = (props) => {
  const { deal } = useContext(DealContext);
  const { openMenu } = useGlobalContext();
  const isLarge = useIsLarge();

  const shouldMakeRoomForMenu = !isLarge && !!openMenu;
  const isCollapsed = !canOpenNavigationForDeal(deal) || shouldMakeRoomForMenu;

  return (
    <Navigation isCollapsed={isCollapsed} department={deal?.department} client={deal?.client} {...props}>
      {deal && <Deal key={deal.id} deal={deal} initiallyCollapsed={false} />}
    </Navigation>
  );
};

export default DealsNavigation;
